"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNABLE_TO_UNLINK_DEVICE = exports.UNABLE_TO_UPDATE_DEVICE = exports.UNABLE_TO_FETCH_DEVICES = void 0;
exports.UNABLE_TO_FETCH_DEVICES = 'UNABLE_TO_FETCH_DEVICES_INFORMATION';
exports.UNABLE_TO_UPDATE_DEVICE = 'UNABLE_TO_UPDATE_DEVICE';
exports.UNABLE_TO_UNLINK_DEVICE = 'UNABLE_TO_UNLINK_DEVICE';
